import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_AUDIO_BOOKS_SET_DATA,
  SEARCH_SEARCH_AUDIO_BOOKS_RESET_DATA,
} from 'rebook/apps/search/constants';


export const fetchInitialData = (location = {}) => {
  return async(dispatch, getState) => {
    const { ssr, searchAudioBooks: currentState } = getState();
    const limit = 10;
    const pageNumber = parseInt(get(ssr, 'query.page', 1));
    const queryParams = queryString.parse(location.search);

    let newState = {
      pageNumber,
      query: get(queryParams, 'q', null),
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
        lastPageNumber: Math.ceil(location.state.audioBooksCount / limit),
      };
    }

    dispatch(setData(newState));
    if (!newState.audioBookList || currentState.pageNumber !== pageNumber) {
      await dispatch(fetchAudioBook(pageNumber));
    }
  };
};

export const fetchAudioBook = (pageNumber = 1) => {
  return async(dispatch, getState) => {
    const { ssr, searchAudioBooks: currentState } = getState();
    const limit = 10;
    let query;

    dispatch(setData({ isLoading: true }));

    if (ssr.query && ssr.query.q) {
      query = ssr.query.q;
    }
    else {
      query = get(ssr, 'query.q', currentState.query);
    }

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    const queryParams = {
      q: query,
      limit,
      offset: (pageNumber - 1) * limit,
    };
    const qs = queryString.stringify(queryParams);
    const url = `/api/search/audiobooks/?${qs}`;

    return await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        const lastPageNumber = Math.ceil(data.meta.total_count / limit);

        dispatch(setData({
          audioBookList: data.objects,
          audioBooksCount: data.meta.total_count,
          query,
          pageNumber,
          lastPageNumber,
          isLoading: false,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load audio book list book due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load audio book list book detail due to server error');
        }
      });
  };
};

const setSeoMeta = () => {
  return (dispatch, getState) => {
    const { ssr, searchAudioBooks: currentState } = getState();
    let audioBookName;

    if (ssr.query && ssr.query.q) {
      audioBookName = ssr.query.q;
    }
    else {
      audioBookName = get(ssr, 'query.q', currentState.query);
    }

    const title = `Все аудиокниги по запросу «${audioBookName}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    const { audioBookList } = payload;
    dispatch({
      type: SEARCH_SEARCH_AUDIO_BOOKS_SET_DATA,
      payload,
    });
    if (audioBookList) {
      dispatch(setSeoMeta());
    }
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_AUDIO_BOOKS_RESET_DATA,
    });
  };
};
